<script setup>
import { computed, onUnmounted } from "vue";
import { useQuizStore } from "@/stores/storeQuiz";
import { useRequestsStore } from "@/stores/storeRequests";
import { sendMetrik } from '@/utils/metrika'
import BaseButtonUploadReceipt from "@/components/ui/BaseButtonUploadReceipt.vue";
const storeQuiz = useQuizStore();
const storeRequests = useRequestsStore();

const subtitle = computed(() => (storeRequests.isAuthenticated ? "Чтобы принять участие в розыгрыше эксклюзивных призов, среди лучших игроков, загрузите чек согласно правилам Акции." : "Чтобы сохранить свои результат необходимо зарегистрироваться и загрузить чек согласно правилам Акции."));
const texth3 = computed(() => (storeRequests.isAuthenticated ? "Не упустите эту возможность – присоединяйтесь к розыгрышу прямо сейчас!" : "Не упустите этот шанс – присоединяйтесь к розыгрышу эксклюзивных призов прямо сейчас!"));
const textBtn = computed(() => (storeRequests.isAuthenticated ? "Загрузить чек" : "Зарегистрироваться"));
onUnmounted(() => {
	storeQuiz.restartGame();	
	sendMetrik('reachGoal', 'Fillword_fin')
})
</script>
<template>
	<div :class="['quiz-end-game', { '--assecs': storeQuiz.isShowResultGame }]">
		<div class="container">
			<div class="quiz-end-game__container">
				<div class="quiz-end-game__block" v-if="storeQuiz.isShowResultGame">
					<h2 class="quiz-end-game__title">Поздравляем!</h2>
					<p class="quiz-end-game__subtitle">{{ subtitle }}</p>
					<div class="quiz-end-game__box">
						<h3>{{ texth3 }}</h3>
						<p v-if="storeRequests.isAuthenticated">Чем больше чеков и успешных прохождений игры, тем выше шанс на призы!</p>
						<BaseButtonUploadReceipt class="quiz-end-game__btn --blue">{{ textBtn }}</BaseButtonUploadReceipt>
					</div>
				</div>

				<div class="quiz-end-game__block" v-else>
                    <h2 class="quiz-end-game__title">Не расстраивайтесь!</h2>
					<p class="quiz-end-game__subtitle">У Вас есть шанс попробовать еще раз и участвовать <br> в розыгрыше эксклюзивных призов!</p>
                    <button class="quiz-end-game__btn btn --blue" @click="storeQuiz.restartGame()">Пройти еще раз</button>
                </div>
			</div>
		</div>
	</div>
</template>
<style lang="scss" scoped>
@use "@/assets/scss/base/vars";
.quiz-end-game {
    position: relative;
	padding: 8rem 0 15rem;
	color: #fff;
	background-image: url("@/assets/img/games/game_line_1.webp"), url("@/assets/img/games/game_line_2.webp");
	background-repeat: no-repeat;
	background-position: 0% 0%, 100% 100%; /* x y*/
	background-size: 16%, 18%;
	@media (max-width: vars.$xx) {
		background-image: none;
		padding: 4.5rem 0 7rem;
	}

	&.--assecs {
		background-image: url("@/assets/img/games/game_line_0.webp"), url("@/assets/img/games/game_line_2.webp");
		background-repeat: no-repeat;
		background-position: 0% 61%, 100% 100%; /* x y*/
		background-size: 34%, 18%;
		@media (max-width: vars.$xx) {
			background-image: none;
		}
        .quiz-end-game__box {

            &::before {
                position: absolute;
                content: '';
                background-image: url('@/assets/img/games/game_gift.webp');
                background-repeat: no-repeat;
                background-position: 0px 0px; /* x y*/
                background-size: contain; /* w h*/
                width: 44rem;
                height: 44rem;
                right: -34%;
                bottom: -34%;
                z-index: 1;
                @media (max-width: vars.$mn) {
                    width: 30rem;
                    height: 30rem;
                    right: -13%;
                    bottom: -25%;
                }
                @media (max-width: vars.$xx) {
                    display: none;
                }
            }
        }
        .quiz-end-game__container {
            max-width: 82.2rem;
        }
	}
}

.quiz-end-game__container {
	display: flex;
	align-items: center;
    justify-content: center;
	flex-direction: column;
    max-width: 99.6rem;
    margin: 0 auto;
}
.quiz-end-game__block {
    display: flex;
    align-items: center;
    flex-direction: column;
}
.quiz-end-game__title {
	font-weight: 700;
	font-size: 7.2rem;
	line-height: 140%;
	text-transform: uppercase;
	text-align: center;
	margin-bottom: 2.2rem;
    @media (max-width: vars.$x480) {
		font-size: 3.4rem;
	}
}
.quiz-end-game__subtitle {
	font-weight: 400;
	font-size: 2.4rem;
	line-height: 140%;
	text-align: center;	
	margin-bottom: 5rem;
    @media (max-width: vars.$x480) {
        font-size: 2rem;
    }
}
.quiz-end-game__box {
	position: relative;
	display: flex;
	align-items: center;
	flex-direction: column;
    gap: 4rem;
	border-radius: 3.2rem;
    padding: 5.5rem 5.8rem;
	background: var(--system-fill-light);
	color: var(--text-accent-1-100);
	text-align: center;
    @media (max-width: vars.$x480) {
        padding: 40px 30px;
        border-radius: 2rem;
        gap: 2rem;
    }
	h3 {
		font-weight: 500;
		font-size: 3.2rem;
		line-height: 120%;
        @media (max-width: vars.$x480) {
            font-size: 2.4rem;
        }
	}
	p {
		font-weight: 400;
		font-size: 2.4rem;
		line-height: 140%;
        @media (max-width: vars.$x480) {
            font-size: 1.8rem;
        }
	}
}
.quiz-end-game__btn {
}
.--blue {
}
</style>
